import { render, staticRenderFns } from "./ConfigRecordDialog.vue?vue&type=template&id=3ce57753&scoped=true&"
import script from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce57753",
  null
  
)

export default component.exports